import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';

@Component({
  selector: 'multiselect-field',
  templateUrl: './multiselect-field.component.html',
  styleUrls: ['./multiselect-field.component.scss']
})
export class MultiselectFieldComponent implements OnInit, OnChanges {

  @Input() fieldError?: string;
  @Input() label?: string;
  @Input() required?: boolean;
  @Input() records?: any[];
  @Input() disabled?: boolean;
  @Input() defaultSelection?: number;
  @Input() id: string;

  @Output() optionsSelected: EventEmitter<number[]> = new EventEmitter();


  isDisabled?: boolean;
  isOpen: boolean = false;
  animate: boolean = false;

  // form model
  msModel: any = {
    multiselect: 'All',
    selectAll: true,
    selected: []
  };

  selected: any[] = [];

  constructor() { }

  ngOnInit() {  
    this.isDisabled = this.disabled ? true : false;
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.records && !changes.records.firstChange && !this.defaultSelection) {
      this.onSelectAll();
    }
    else if(changes.records && changes.records.firstChange && this.defaultSelection){
      this.setMultiSelectDefaultValue(true);
    }
  }


  /**
   * Open menu event handler
   * @param e
   */
  openMenu(e: any): void {

    e.preventDefault();

    if (this.isDisabled) {
      return;
    }

    setTimeout(() => {

      this.isOpen = true;
      setTimeout(() => {
        this.animate = true;
      }, 100);

    }, 100);

  }

  /**
   * Close menu event handler
   */
  closeMenu(): void {
    this.animate = false;
    this.isOpen = false;
  }

  /**
   * Option click event handler
   * @param e
   * @param Id
   */
  toggleCheckbox(e: any, Id: number): void {

    // stop menu from closing
    e.preventDefault();
    e.stopPropagation();

    this.msModel.selected[Id] = this.msModel.selected[Id] ? false : true;
    if (e.target.nodeName === 'INPUT') {
      setTimeout(() => {
        e.target.checked = this.msModel.selected[Id];
      }, 100);
    }

    this.updateMultiselectValue(false);

  }

  /**
   * Select all event handler
   * stop propagation
   * @param e
   */
  toggleAll(e: any) {
    e.stopPropagation();
  }

  /**
   * Closes the menu if tab key is pressed
   * @param e
   */
  onKeyup(e: any): void {

    if (e.keyCode === 9) {
      this.closeMenu();
    }

  }

  /**
   * Update the field value and broadcast selected items
   */
  updateMultiselectValue(isFirstChange: boolean): void {

    const sel: any = Object.keys(this.msModel.selected);

    this.selected.length = 0;
    if (!this.defaultSelection || this.defaultSelection && !isFirstChange) {
      for (let i = 0; i < sel.length; i++) {
        if (this.msModel.selected[sel[i]]) {
          const id: number = Number(sel[i]);
          this.selected.push(id);
        }
      }

      if (this.selected.length !== 0) {
        this.msModel.multiselect = `${this.selected.length} selected`;
        this.msModel.selectAll = false;
      } else {
        this.msModel.multiselect = 'All';
        this.msModel.selectAll = true;
      }
    }
    else {
      this.selected.push(this.defaultSelection);
      this.msModel.multiselect = `1 selected`;
      this.msModel.selectAll = false;
    }

    this.optionsSelected.emit(this.selected);

  }

  /**
   * Checkbox change event handler
   */
  onChange(): void {
    this.updateMultiselectValue(false);
  }

  /**
   * Select all checkbox event handler
   */
  onSelectAll(_e?: any): void {

    // reset selected
    this.msModel.selected.length = 0;

    // update field value
    setTimeout(() => {
      this.updateMultiselectValue(false);
    }, 50);

  }

    /**
   * Select all checkbox event handler
   */
    setMultiSelectDefaultValue(isFirstChange: boolean): void {

      // reset selected
      this.msModel.selected[this.defaultSelection] = true;
  
      // update field value
      setTimeout(() => {
        this.updateMultiselectValue(isFirstChange);
      }, 50);
  
    }

}
